import { msg } from "@lingui/core/macro";
import { createSignal, onCleanup, onMount, Show } from "solid-js";
import { CloudOff } from "@fleet/icons";
import { useI18n } from "@/providers/i18n-provider";

/** Periodic recheck: online/offline events can be lost (suspended tab,
 * emulation, interface changes) and a stuck banner lies. */
const POLL_MS = 3000;

export function OfflineBanner() {
  const { t } = useI18n();
  const [isOnline, setIsOnline] = createSignal(navigator.onLine);

  onMount(() => {
    const sync = () => setIsOnline(navigator.onLine);

    globalThis.addEventListener("online", sync);
    globalThis.addEventListener("offline", sync);
    const interval = setInterval(sync, POLL_MS);

    onCleanup(() => {
      globalThis.removeEventListener("online", sync);
      globalThis.removeEventListener("offline", sync);
      clearInterval(interval);
    });
  });

  // Mounted ONLY when there truly is no network: a banner "collapsed but
  // mounted" still occupied the accessibility tree and confused
  // visibility checks (clipped content keeps its bounding box).
  return (
    <Show when={!isOnline()}>
      <div
        class="animate-in slide-in-from-top flex h-10 items-center justify-center gap-2 bg-amber-500 px-4 text-center text-xs font-bold text-amber-950"
        role="status"
        data-testid="offline-banner"
      >
        <CloudOff class="h-4 w-4" />
        {t(msg`You are working in offline mode. Changes will sync when connection is restored.`)}
      </div>
    </Show>
  );
}
